/**
 * Redirect component for '/'
 * 
 * Admin users don't want to be forwarded to /agenda
 * Check user role and forward accordingly
 */

// import primary libraries
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

class RedirectToRoleBasedRoot extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    const agendaLink = `${window.agendaUrl}/agenda`
    const { isAdmin } = this.props;
    if (isAdmin) {
      return <Redirect to={'/admin'}/>
    }
    // agenda link is a separate subdomain so we can't use react-router redirects
    window.location.href = agendaLink;
  }
}

const mapStoreToProps = (store) => {
  const loggedInUser = store.user.loggedIn.user;
  const isAdmin = loggedInUser && loggedInUser.admin;
  return {
    isAdmin
  }
}

export default connect(
  mapStoreToProps
)(RedirectToRoleBasedRoot);



// WEBPACK FOOTER //
// global/components/routing/RedirectToRoleBasedRoot.js.jsx